import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import datepickerMixin from 'js/mixins/datepicker.js'
import * as XLSX from 'xlsx'

import journeysTab from 'js/components/journeys/tab_contents/journey'
import productsTab from 'js/components/journeys/tab_contents/product'
import cardTab from 'js/components/journeys/tab_contents/card'
import genericSvgIcon from 'js/components/_moverick/generic-svg-icon'

import template from './index.pug'

const TSC_CODE = 1
const QR_ID_CODE = 2
const PROD_CODE = 3
const TNE_CODE = 4

export default Vue.extend({
  name: 'travel-index-page',
  template: template(),
  components: {journeysTab, productsTab, cardTab, genericSvgIcon},
  mixins: [datepickerMixin],
  data() {
    return {
      // Filtros de la vista
      activeTabId: 'tab_0',
      products: [],
      paginationTravels: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      },
      order: {
        order_by: 'code',
        order_dir: 'asc'
      },
      paginationProducts: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      },
      paginationTscs: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      }
    }
  },

  computed: {
    ...mapGetters('user', [
      'tscs',
      'journeysByYearMonth',
      'fullClient',
      'travels',
      'filters'
    ]),
    ...mapGetters([
      'loadingTravels',
      'okProfile',
      'currentAlias'
      // 'getOperatorIds',
    ]),

    hasData() {
      if (this.inProductTab) {
        return !_.isEmpty(this.$store.getters['user/products'])
      }

      return !_.isEmpty(this.travels)
    },

    paymentMethod: {
      get() {
        return this.$store.getters.paymentMethod
      },
      set(val) {
        this.$store.commit('user/setPaymentMethod', val)
      }
    },

    selectedTscMediaCode: {
      get() {
        return this.$store.getters.selectedTscMediaCode
      },
      set(val) {
        this.$store.commit('user/setSelectedTscMediaCode', val)
      }
    },

    availableTabs() {
      const tabs = [
        {
          id: QR_ID_CODE,
          title: this.$t(`travels.tabs.${QR_ID_CODE}`),
          component: 'journeys-tab'
        },
        {
          id: TSC_CODE,
          title: this.$t(`travels.tabs.${TSC_CODE}`),
          component: 'journeys-tab'
          // component: 'card-tab'
        }
      ]

      if (_.get(this.$administrativeArea, 'config.product_available', false)) {
        tabs.push({
          id: PROD_CODE,
          title: this.$t(`travels.tabs.${PROD_CODE}`),
          component: 'products-tab'
        })
      }

      return tabs
    },

    activeTab() {
      const matches = this.activeTabId.match(/\d+$/)

      return matches ? parseInt(matches[0], 10) : 0
    },

    selectedTab() {
      return this.availableTabs[this.activeTab]
    },

    getTravelsParams() {
      const params = {
        media_type_array: this.selectedMediaTypes,
        client_travels_media_type: this.mediaTypeInt
      }

      if (this.inTscTab && this.selectedTscMediaCode) {
        params.media_code = this.selectedTscMediaCode
      }

      return params
    },

    inAccountTab() {
      return this.mediaTypeInt === QR_ID_CODE
    },

    inTscTab() {
      return this.mediaTypeInt === TSC_CODE
    },

    inProductTab() {
      return this.mediaTypeInt === PROD_CODE
    },

    selectedMediaTypes() {
      if (this.mediaTypeInt === QR_ID_CODE) return [QR_ID_CODE, TNE_CODE]
      if (this.mediaTypeInt === TSC_CODE) return [TSC_CODE]

      return []
    },

    tscOptions() {
      return this.tscs.map(tsc => ({
        label: this.$t('travels.tscOption', tsc).trim(),
        value: tsc.CardSerialNumber
      }))
    },

    hasMultipleTscs() {
      return !_.isEmpty(this.tscOptions)
    },

    /**
     * Cleans up the mediatype and returns the Int
     * @returns {Number}
     */
    mediaTypeInt() {
      const type = parseInt(this.selectedTab?.id || 0, 10)

      return type
    }
  },

  watch: {

    tscs() {
      this.selectFirstTsc()
    },

    selectedTscMediaCode() {
      if (!this.inTscTab) return
      this.getTravels(this.getTravelsParams)
    }

    // getOperatorIds(newVal, oldVal) {
    //   if (newVal !== oldVal) this.getOperators()
    // }
  },

  // mounted() {
  //   this.$nextTick(() => {
  //     const vm = this
  //     if (Array.isArray(this.travels)) {
  //       this.travels.forEach(journey => {
  //         const id = `travel-${journey.id}`
  //         if (!id) return
  //         const boton = document.getElementById(id)
  //         // Agregar un listener para el evento focus
  //         boton.addEventListener('focus', () => {
  //           const textoescuchar = left.$t('textoVoz.selectorLinea')
  //           vm.escucharAudio(textoescuchar)
  //           vm.opcionSelectotLinea = 0
  //         })
  //       })
  //     }
  //   })
  // },

  async created() {
    if (!this.fullClient || Object.keys(this.fullClient).length === 0) {
      await this.$store.dispatch('user/getAllClientData')
    }

    await this.$store.dispatch('getOperators')
    this.$store.commit('user/setTransactions', this.fullClient?.transactions || [])
    this.$store.commit('user/setMediaType', QR_ID_CODE)
    await this.$store.dispatch('user/getTravels', this.getTravelsParams)
  },

  methods: {
    ...mapActions('user', [
      'getTravels',
      'getProducts'
    ]),

    setTravelSelection({mediaType, paymentMethod = '', selectedTscMediaCode = ''}) {
      this.$store.commit('user/setMediaType', mediaType)
      this.$store.commit('user/setPaymentMethod', paymentMethod)
      this.$store.commit('user/setSelectedTscMediaCode', selectedTscMediaCode)
    },

    refreshActiveTabData() {
      if (this.inProductTab) {
        return this.getProducts()
      }

      return this.getTravels(this.getTravelsParams)
    },

    changeTab() {
      if (this.inAccountTab) {
        this.setTravelSelection({mediaType: this.mediaTypeInt})

        this.refreshActiveTabData()

        return
      }

      if (this.inTscTab) {
        this.setTravelSelection({mediaType: this.mediaTypeInt})
        this.selectFirstTsc()

        if (!this.selectedTscMediaCode) {
          this.refreshActiveTabData()
        }

        return
      }

      if (this.inProductTab) {
        this.setTravelSelection({mediaType: this.mediaTypeInt})
        this.refreshActiveTabData()
      }
    },

    changeLimitTravels(limit) {
      this.paginationTravels.limit = limit
      this.paginationTravels.currentPage = 1
      this.getTravels(this.getTravelsParams)
    },

    changePageTravels(page) {
      this.paginationTravels.currentPage = page
      this.getTravels(this.getTravelsParams)
    },

    changeLimitTscs(limit) {
      this.paginationTscs.limit = limit
      this.paginationTscs.currentPage = 1
      this.getTravels(this.getTravelsParams)
    },

    changePageTscs(page) {
      this.paginationTscs.currentPage = page
      this.getTravels(this.getTravelsParams)
    },

    changeLimitProducts(limit) {
      this.paginationProducts.limit = limit
      this.paginationProducts.currentPage = 1
      this.getProducts()
    },

    changePageProducts(page) {
      this.paginationProducts.currentPage = page
      this.getProducts()
    },

    /*
     * Seleccionar la primera TSC que haya
     * si no hay ninguna seleccionada
     */
    selectFirstTsc() {
      if (!_.isEmpty(this.tscs)) {
        const selectedTsc = this.tscs.find(
          tsc => tsc.CardSerialNumber === this.selectedTscMediaCode
        )

        if (selectedTsc === undefined) {
          this.selectedTscMediaCode = this.tscs[0].CardSerialNumber
        }
      } else {
        this.selectedTscMediaCode = ''
      }
    },

    getMediaTypeNoDataText() {
      if (this.mediaTypeInt === TSC_CODE) {
        return this.$t('travels.noTravelsTsc')
      } else if (this.mediaTypeInt === PROD_CODE) {
        return this.$t('travels.noTravelsProduct')
      }

      return this.$t('travels.noTravelsQR')
    },

    getMediaTypeNoDataImg() {
      if (this.mediaTypeInt === TSC_CODE) {
        return require('assets/images/ilustrations/private-area/no-travels-tsc.svg')
      } else if (this.mediaTypeInt === PROD_CODE) {
        return require('assets/images/ilustrations/private-area/no-travels-product.svg')
      }

      return require('assets/images/ilustrations/private-area/no-travels-qr.svg')
    },

    travelTranslationObject(travel) {
      return {
        mediaType: this.$t(`travels.mediaTypes.${travel.media_type}`),
        mediaCode: travel.media_code
      }
    },
    downloadCsv() {
      const sheetAllData = []
      const worksheets = {}

      const filename = `${this.$t('travels.title')} - ${this.dateRange[0]} - ${this.dateRange[1]}`
      const headers = [
        this.$t('travels.fecha'),
        this.$t('travels.hora'),
        this.$t('travels.monto'),
        this.$t('travels.formapago'),
        this.$t('travels.origen'),
        this.$t('travels.linea'),
        this.$t('travels.perfil')
      ]

      sheetAllData.push(headers)

      Object.entries(this.journeysByYearMonth).forEach(([y, yData]) => {
        Object.entries(yData).forEach(([m, mData]) => {
          Object.entries(mData).forEach(([, dData]) => {
            const sheetname = `${this.$t(`dates.months.${parseInt(m)}`)} ${y}`
            const monthData = [headers]
            dData.forEach(journey => {
              const row = [
                moment(journey.operation_date).format('DD/MM/YYYY'),
                moment(journey.operation_date).format('HH:mm'),
                this.$options.filters.moverickCurrency(journey.amount || 0),
                this.$store.getters['user/getPaymentTypeText'](journey.media_type),
                journey.route.origin,
                journey.route.subline_name,
                journey.media_code
              ]
              sheetAllData.push(row)
              monthData.push(row)
            })
            worksheets[sheetname] = monthData
          })
        })
      })

      try {
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.aoa_to_sheet(sheetAllData)
        XLSX.utils.book_append_sheet(wb, ws,
          this.$options.filters.titleCase(this.$t('travels.all')))

        Object.entries(worksheets).forEach(([sheetName, sheetData]) => {
          const worksheet = XLSX.utils.aoa_to_sheet(sheetData)
          XLSX.utils.book_append_sheet(wb, worksheet, this.$options.filters.titleCase(sheetName))
        })

        XLSX.writeFile(wb,
          this.$options.filters.titleCase(`${filename}.xlsx`))
      } catch (err) {
        console.error('Error creating excel: ', err)
      }
    }
  }
})
